<div class="sp-flip-shell">

  <!-- Top bar -->
  <div class="sp-flip-topbar">
    <button class="sp-flip-back" (click)="close()" title="Close reader view">
      <span class="material-icons">arrow_back</span>
      <span>Back to documents</span>
    </button>
    <div class="sp-flip-title">
      <span class="material-icons">menu_book</span>
      <span>{{ fileName }}</span>
      <span class="sp-flip-pageref" *ngIf="totalPages > 0">
        page {{ currentPage + 1 }} / {{ totalPages }}
      </span>
    </div>
    <div class="sp-flip-topbar-spacer"></div>
    <div class="sp-flip-next-hint" *ngIf="showNextHint && currentPage >= totalPages - 2">
      <span>Next: {{ nextDocName }}</span>
      <span class="material-icons">arrow_forward</span>
    </div>
  </div>

  <!-- Body: book + intelligence panel -->
  <div class="sp-flip-body" [class.sp-no-ai]="!sector.feature('aiChat')">

    <!-- Loading -->
    <div class="sp-flip-loading" *ngIf="isLoading && !hasError">
      <div class="sp-flip-spinner"></div>
      <div *ngIf="!renderTotal">Preparing document for reader view…</div>
      <div *ngIf="renderTotal">Preparing pages… {{ renderProgress }} / {{ renderTotal }}</div>
      <div *ngIf="renderTotal" style="width:220px;max-width:60vw;height:6px;border-radius:3px;background:rgba(0,0,0,0.1);overflow:hidden;margin-top:6px;">
        <div [style.width.%]="(renderProgress / renderTotal) * 100"
             style="height:100%;background:#244062;transition:width .15s;"></div>
      </div>
      <button type="button" (click)="backToList()"
              style="margin-top:14px;padding:6px 14px;border:1px solid #d1d5db;border-radius:6px;background:#fff;color:#374151;cursor:pointer;font-size:13px;">
        Cancel &amp; back to list
      </button>
    </div>

    <!-- Error -->
    <div class="sp-flip-error" *ngIf="hasError">
      <span class="material-icons">error_outline</span>
      <div>{{ errorMessage }}</div>
      <button (click)="close()">Back</button>
    </div>

    <!-- Book + controls -->
    <div class="sp-flip-stage" *ngIf="!isLoading && !hasError">
      <button class="sp-flip-nav sp-flip-nav--prev" (click)="flipPrev()" title="Previous">
        <span class="material-icons">chevron_left</span>
      </button>

      <div class="sp-flip-canvas">
        <div #flipBook class="sp-flip-book"></div>
      </div>

      <button class="sp-flip-nav sp-flip-nav--next" (click)="flipNext()" title="Next">
        <span class="material-icons">chevron_right</span>
      </button>
    </div>

    <!-- Intelligence panel — only when the AI feature is enabled for this site -->
    <aside class="sp-flip-panel" *ngIf="!isLoading && !hasError && sector.feature('aiChat')">

      <!-- Claim header -->
      <div class="sp-panel-header" *ngIf="meta.caseId">
        <div class="sp-panel-eyebrow">{{ meta.caseType === 'motorClaim' ? 'Motor claim' : 'Medical claim' }}</div>
        <h2>{{ meta.caseId }}</h2>
        <div class="sp-panel-meta">
          <span class="sp-pill sp-pill--status">{{ meta.status || 'OPEN' }}</span>
          <span class="sp-pill" *ngIf="meta.policyNo">Policy: {{ meta.policyNo }}</span>
        </div>
      </div>

      <!-- AI summary -->
      <div class="sp-panel-section">
        <div class="sp-section-label">
          <span class="material-icons">auto_awesome</span>
          AI summary
        </div>
        <p class="sp-panel-summary">{{ insight.summary }}</p>
      </div>

      <!-- Checklist -->
      <div class="sp-panel-section" *ngIf="insight.checklist.length">
        <div class="sp-section-label">
          <span class="material-icons">fact_check</span>
          Document checklist
          <span class="sp-section-meta">{{ checklistCompleteness }}</span>
        </div>
        <ul class="sp-checklist">
          <li *ngFor="let item of insight.checklist"
              [class.sp-checklist-item--missing]="!item.present">
            <span class="material-icons">{{ item.present ? 'check_circle' : 'radio_button_unchecked' }}</span>
            {{ item.label }}
          </li>
        </ul>
      </div>

      <!-- Risk flags -->
      <div class="sp-panel-section" *ngIf="insight.risks.length">
        <div class="sp-section-label">
          <span class="material-icons">warning_amber</span>
          Risks &amp; flags
        </div>
        <ul class="sp-risk-list">
          <li *ngFor="let risk of insight.risks">{{ risk }}</li>
        </ul>
      </div>

      <!-- Suggested asks -->
      <div class="sp-panel-section" *ngIf="insight.suggestedAsk.length">
        <div class="sp-section-label">
          <span class="material-icons">forum</span>
          Ask the assistant
        </div>
        <div class="sp-ask-chips">
          <button class="sp-ask-chip"
                  *ngFor="let q of insight.suggestedAsk"
                  (click)="askAi(q)">
            {{ q }}
          </button>
        </div>
      </div>

      <!-- Key fields -->
      <div class="sp-panel-section" *ngIf="meta.vehicleReg || meta.memberNumber">
        <div class="sp-section-label">
          <span class="material-icons">badge</span>
          Key fields
        </div>
        <dl class="sp-keyfields">
          <ng-container *ngIf="meta.memberName">
            <dt>Member</dt><dd>{{ meta.memberName }}</dd>
          </ng-container>
          <ng-container *ngIf="meta.memberNumber">
            <dt>Member no.</dt><dd>{{ meta.memberNumber }}</dd>
          </ng-container>
          <ng-container *ngIf="meta.vehicleReg">
            <dt>Vehicle</dt><dd>{{ meta.vehicleReg }}</dd>
          </ng-container>
          <ng-container *ngIf="meta.estimatedLoss">
            <dt>Estimated loss</dt><dd>KES {{ meta.estimatedLoss | number }}</dd>
          </ng-container>
          <ng-container *ngIf="meta.claimedAmount">
            <dt>Claimed</dt><dd>KES {{ meta.claimedAmount | number }}</dd>
          </ng-container>
        </dl>
      </div>

    </aside>
  </div>
</div>
